import { from } from 'rxjs';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import loadFirebase, { getFirebaseApp } from '../firebase';
import { getImpersonationSession } from '../../helpers/impersonation';

let database = null;
let databasePromise = null;
const localDatabaseInstances = new WeakSet();

const loadDatabase = async () => {
    await loadFirebase();
    await import('firebase/compat/firestore');

    const db = getFirebaseApp().firestore();

    if (process.env.FB_EMULATOR === 'true' && !localDatabaseInstances.has(db)) {
        db.useEmulator('127.0.0.1', Number(process.env.LOCAL_FIRESTORE_PORT || 8080));
        localDatabaseInstances.add(db);
    }

    try {
        if (process.env.FB_EMULATOR !== 'true' && !getImpersonationSession()) {
            await db.enablePersistence();
        }
    } catch (err) {
        if (!['failed-precondition', 'unimplemented'].includes(err.code)) {
            console.error('Firestore persistence error', err.stack || err);
        }
    }

    return db;
};

export const getDatabase = async () => {
    if (database) {
        return database;
    }

    if (!databasePromise) {
        databasePromise = loadDatabase();
    }

    database = await databasePromise;
    return database;
};

export const getModularDatabase = async () => {
    await loadFirebase();
    const db = getFirestore(getFirebaseApp());

    if (process.env.FB_EMULATOR === 'true' && !localDatabaseInstances.has(db)) {
        connectFirestoreEmulator(db, '127.0.0.1', Number(process.env.LOCAL_FIRESTORE_PORT || 8080));
        localDatabaseInstances.add(db);
    }

    return db;
};

export const getDatabase$ = from(getDatabase());

export default getDatabase;
